import React from 'react';
import DatePicker from 'pureUi/DatePicker';
import { LegendColourBlock } from './StaticRateAvailabilityCalendar';
import { MobileBottomDrawer } from 'ui/MobileBottomDrawer/MobileBottomDrawer';
import { formatDateTimeDisplayWithoutOffset } from 'utils';

interface IAvailabilityCalendarDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  date: string;
  onNextClick: () => void;
  onPrevClick: () => void;
  availableDates: string[];
  unavailableDates: string[];
  requestDates: string[];
  error?: string;
  hotelAvailabilityImportedAt?: string | null;
}

export const AvailabilityCalendarDrawer = (props: IAvailabilityCalendarDrawerProps) => {
  return (
    <MobileBottomDrawer isOpen={props.isOpen} onClose={props.onClose}>
      <span className="block font-hurmegeometric-sans text-sm uppercase text-flint font-bold mb-[15px]">
        Availability
      </span>

      <div className="[&>*]:!w-full [&>*]:!shadow-none [&_.calendars]:!w-full [&_.calendar]:!w-full [&_.calendarGrid]:!w-auto">
        <DatePicker
          calendarCount={1}
          currentDate={props.date}
          selectedDates={[]}
          onDayClick={() => {}}
          onDayMouseOver={() => {}}
          onNextClick={() => {
            props.onNextClick();
          }}
          onPrevClick={() => {
            props.onPrevClick();
          }}
          minDate={'2000-01-01'}
          maxDate={'2100-01-01'}
          enablePastDates={true}
          availableDates={props.availableDates}
          unavailableDates={props.unavailableDates}
          requestDates={props.requestDates}
          readonly
        />
      </div>

      {props.error && (
        <React.Fragment>
          <p className="text-red-95 text-center text-13px my-2">
            There was an error loading the static rate availability information for this hotel.
          </p>
          <p className="text-red-95 text-center text-13px my-2">Please refresh the page and try again.</p>
        </React.Fragment>
      )}

      {props.error === undefined && props.hotelAvailabilityImportedAt && (
        <p className="text-flint text-center text-13px font-hurmegeometric-sans mb-0">
          Last Updated: {formatDateTimeDisplayWithoutOffset(props.hotelAvailabilityImportedAt)}
        </p>
      )}

      {props.error === undefined && (
        <div className="flex flex-wrap items-center justify-center gap-[10px] pt-10px pb-10px font-hurmegeometric-sans text-13px">
          <span className="flex items-center">
            <LegendColourBlock availabilityStatus="available" />
            <span className="text-flint ml-5px">Available</span>
          </span>
          <span className="flex items-center">
            <LegendColourBlock availabilityStatus="unavailable" />
            <span className="text-flint ml-5px">Not Available</span>
          </span>
          <span className="flex items-center">
            <LegendColourBlock availabilityStatus="request" />
            <span className="text-flint ml-5px">On Request</span>
          </span>
          <span className="flex items-center">
            <LegendColourBlock availabilityStatus="no-data" />
            <span className="text-flint ml-5px">No Data</span>
          </span>
        </div>
      )}
    </MobileBottomDrawer>
  );
};
